// src/components/Home.js
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Home() {
  const { authState } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState.isAuthenticated) {
      navigate('/chat');
    }
  }, [authState.isAuthenticated, navigate]);

  return (
    <main
      className="br-spirit-home text-white"
      data-testid="spirit-homepage"
      style={{
        backgroundColor: '#0b2730',
        backgroundImage: "url('/background-celestial.png')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      <div className="br-spirit-home__content">
        <div className="br-spirit-home__card animate-pulseGlow">
          <p className="br-eyebrow">A steady place to think</p>
          <h1>BrightResolve</h1>
          <p className="br-spirit-home__lead">
            Thoughtful support when clarity matters most
          </p>

          <div className="br-spirit-home__actions">
            <Link
              to="/register"
              className="br-button br-button--primary"
            >
              Register
            </Link>
            <Link
              to="/login"
              className="br-button"
            >
              Sign In
            </Link>
          </div>
        </div>

        <footer className="br-spirit-home__footer">
          BrightResolve is an artificial intelligence system designed for natural conversation. It is not a person or conscious being.
        </footer>
      </div>
    </main>
  );
}
